/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const AirplaneDiagonalBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path d="M19.095 3.228c.479-.35 1.134-.29 1.55.127.417.416.476 1.071.127 1.55-.559.768-1.414 1.891-2.117 2.594L16.62 9.533l1.77 10.129a.512.512 0 0 1-.143.45l-.737.737a.508.508 0 0 1-.827-.154l-3.381-7.844-3.692 3.692.792 2.4a.512.512 0 0 1-.124.522l-.76.76a.508.508 0 0 1-.797-.095l-1.815-3.037-3.037-1.815a.509.509 0 0 1-.095-.797l.76-.76a.512.512 0 0 1 .521-.124l2.4.792 3.693-3.692-7.844-3.38a.508.508 0 0 1-.154-.828l.737-.737a.512.512 0 0 1 .45-.143l10.13 1.77L16.5 5.344c.703-.703 1.826-1.558 2.594-2.117Z" /></svg>);
const AirplaneDiagonal = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={AirplaneDiagonalBase} {...rest} ref={ref} />);
export default AirplaneDiagonal;